import React from 'react';
import { useSite } from '@v2/shared/lib/site';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';
import Render from '@v2/shared/components/Render';

export default function SiteAwareHomeTitle() {
  const site = useSite();
  const brand = site.id.replace(/dev$/, '');
  const { buildUrl } = useUrlGenerator();
  const reviewsUrl = buildUrl('/reviews');

  return (
    <>
      <Render if={brand === 'dm'}>
        <h1 className="font-bold text-xl md:text-2xl mb-3">
          The Best Prices on Over 1 Million Magazine Subscriptions & Books
        </h1>
        <p className="mb-14">
          Welcome to DiscountMags.com, the internet's largest catalog for{' '}
          <strong>print and digital magazine subscriptions</strong>. As a family owned small business operating since
          2002, we take pride in providing readers with the guaranteed lowest prices on a massive selection of best
          sellers and hard to find titles. Explore our collection of over 1,000,000 publications, including books,
          calendars, and digital magazine issues, all with no hidden fees and easy account management. See why so many
          readers have given us{' '}
          <a href={reviewsUrl} className="text-primary">
            5-star reviews
          </a>
          .
        </p>
      </Render>
      <Render if={brand === 'dmca'}>
        <h1 className="font-bold text-xl md:text-2xl mb-3">The Best Prices on Magazine Subscriptions in Canada</h1>
        <p className="mb-14">
          Welcome to DiscountMags.ca, Canada's destination for <strong>discount magazine subscriptions</strong>. As a
          family owned small business operating since 2002, we take pride in providing Canadian readers with the
          guaranteed lowest prices on a massive selection of best sellers and hard to find titles. Explore thousands of
          print magazine subscriptions, all with free shipping across Canada, no hidden fees, and easy account
          management. See why so many readers have given us{' '}
          <a href={reviewsUrl} className="text-primary">
            5-star reviews
          </a>
          .
        </p>
      </Render>
      <Render if={brand === 'dmau'}>
        <h1 className="font-bold text-xl md:text-2xl mb-3">
          The Best Prices on Digital Magazine Subscriptions in Australia
        </h1>
        <p className="mb-14">
          Welcome to DiscountMags Australia, your destination for{' '}
          <strong>discount digital magazine subscriptions</strong>. As a family owned small business operating since
          2002, we take pride in providing Australian readers with the guaranteed lowest prices on a massive selection
          of best sellers and hard to find titles. Explore thousands of digital magazine subscriptions with instant
          access on all your devices, no hidden fees, and easy account management. See why so many readers have given us{' '}
          <a href={reviewsUrl} className="text-primary">
            5-star reviews
          </a>
          .
        </p>
      </Render>
    </>
  );
}
